
import { ScanLine } from "lucide-react";

interface MessageSenderProps {
  type: "user" | "seller" | "ai" | "system";
  merchantName: string;
}

const MessageSender = ({ type, merchantName }: MessageSenderProps) => {
  return (
    <>
      {type === "user" ? (
        <span>You</span>
      ) : type === "seller" ? (
        <span>{merchantName}</span>
      ) : (
        <span className="flex items-center">
          <ScanLine className="h-3.5 w-3.5 mr-1.5 text-green-500" />
          AI Response
        </span>
      )}
    </>
  );
};

export default MessageSender;
